module.exports = __webpack_public_path__ + "img/right-icon.3f85091d.png";